'use strict'

import {ModelBase} from './base'

class Seq extends ModelBase {
	static empty_seq = new Seq(
		{
			empty: true,
			name: '<NONE>',

		}
	)

	constructor(data, rootState) {
		super(data)

		console.debug("Seq.constructor()")

		this._rootState = rootState
	}
}

export {Seq}